export default __webpack_public_path__ + "355b383ddb520858ce56110c29d25145.svg";